import { create } from "zustand";
import { devtools } from "zustand/middleware";

export interface AdminOrganizationsFilter {
	searchAdminOrganizationsTerm: string;
}

interface AdminOrganizationsFiltersState {
	// State
	filters: AdminOrganizationsFilter;

	// Actions
	setFilters: (newFilters: Partial<AdminOrganizationsFilter>) => void;
	clearFilters: () => void;
	setSearchTerm: (term: string) => void;
}

const initialFilters: AdminOrganizationsFilter = {
	searchAdminOrganizationsTerm: ""
};

// DevTools configuration options
const devToolsOptions = {
	// Name of the store in Redux DevTools (helps when you have multiple stores)
	name: "AdminOrganizationsFilters",

	// Enable/disable DevTools based on environment (optional)
	// You could use process.env.NODE_ENV !== 'production' here
	enabled: true,

	// Custom anonymous action type (optional)
	anonymousActionType: "UNKNOWN_ACTION",

	// Serialize options (optional - used for handling complex objects)
	serialize: {
		// Options for handling circular references
		options: true
	}
};

// State persists across React Router navigations (module singleton) and
// resets naturally on page refresh — no localStorage needed.
export const useAdminOrganizationsFiltersStore = create<AdminOrganizationsFiltersState>()(
	// DevTools should be the outermost middleware
	devtools(
		set => ({
			// Initial state
			filters: initialFilters,

			// Actions
			setFilters: newFilters =>
				// The third parameter to set allows us to name the action for DevTools
				set(
					state => ({
						filters: { ...state.filters, ...newFilters }
					}),
					false,
					{
						type: "admin-organizations-filters/setFilters",
						payload: newFilters
					}
				),

			clearFilters: () => set({ filters: initialFilters }, false, "admin-organizations-filters/clearFilters"),

			setSearchTerm: searchAdminOrganizationsTerm =>
				set(
					state => ({
						filters: { ...state.filters, searchAdminOrganizationsTerm }
					}),
					false,
					{
						type: "admin-organizations-filters/setSearchTerm",
						payload: searchAdminOrganizationsTerm
					}
				)
		}),
		// Pass DevTools options as the second parameter to devtools
		devToolsOptions
	)
);
